import { CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { CodereTimerService } from "@mso-services/codereTimer.service";
import { NewBaseService } from "@providers/newBase.service";

export enum TimerTemplate {
  Full = "full",
  Mini = "mini",
  Btn = "btn",
}

@Component({
  selector: "codere-timer",
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: "./codere-timer.component.html",
  styleUrls: ["./codere-timer.component.scss"],
})
export class CodereTimerComponent {
  TEMPLATES = TimerTemplate;
  @Input() template: TimerTemplate = TimerTemplate.Full;
  @Input() sessionTimer = true;
  @Input() localTimer = true;
  @Input() iconSession = true;
  @Input() iconLocal = true;

  newBaseService = inject(NewBaseService);
  codereTimerService = inject(CodereTimerService);
}
